module.exports = __webpack_public_path__ + "34736292/img/revit-icon.5ff0d581.svg";